import CityPageTemplate from "../city-template/CityPageTemplate";
import { virginiaBeachConfig } from "./data";

export default function VirginiaBeachPage() {
  return <CityPageTemplate config={virginiaBeachConfig} />;
}